import axios from 'axios';
import once from 'once';
import {formQuery} from './form-query';
import {convertEmptyStringToNull} from './map-empty-string-to-null';

export * from './qc';
export * from '../Authorization';
export * from './users';
export {formQuery} from './form-query';

const getQcToolsMetadata = async (id: any) => {
    const {data} = await axios(`/api/qc-jobs/${id}/metadata`);
    
    return data;
};

const getQcJobsStatuses = async () => {
    const {data} = await axios('/api/qc-jobs/statuses');
    return data;
};

const getQcReportsStatuses = async () => {
    const {data} = await axios('/api/qc-reports/statuses');
    return data;
};

const createNewIngestItem = async (params: any) => {
    const {body} = params;
    const newParams = convertEmptyStringToNull(body);
    
    return await axios.post(
        '/api/ingest-configs',
        newParams,
    );
};

const editIngestConfigItem = async (params: any) => {
    const {id, body} = params;
    const newParams = convertEmptyStringToNull(body);
    
    return await axios.put(
        `/api/ingest-configs/${id}`,
        newParams,
    );
};

const deleteMediaOrder = async (params: any) => {
    const {
        mediaOrderId,
        mediaOrderItemId,
    } = params;
    
    return await axios.delete(`/api/media-orders/${mediaOrderId}/media-order-items/${mediaOrderItemId}`);
};

const restoreMediaOrder = async (params: any) => {
    const {
        mediaOrderId,
        mediaOrderItemId,
    } = params;
    
    return await axios.put(`/api/media-orders/${mediaOrderId}/media-order-items/${mediaOrderItemId}/restore`);
};

const getIngestConfigItemForEditing = async (id: any) => {
    const {data} = await axios(`/api/ingest-configs/${id}`);
    
    return data;
};

const getSearchedContentItems = async (params: any) => {
    const mappedParams = {
        limit: params.limit,
        offset: params.offset,
        title: '',
        rating: '',
        contentItemType: '',
    };
    const {
        title,
        rating,
        contentType,
    } = params;
    
    if (title) mappedParams.title = title;
    
    if (rating) mappedParams.rating = rating;
    
    if (contentType) mappedParams.contentItemType = contentType;
    
    const query = formQuery(`/api/content-items/search`, mappedParams);
    
    const {data} = await axios(query);
    return data;
};

const getContentPartnersList = async () => {
    const {data} = await axios('/api/content-partners');
    
    return data;
};

const getContentTypesList = async () => {
    const {data} = await axios('/api/ingest-sessions/types');
    
    return data;
};

const getImportMediaOrder = async (body: any) => {
    const data = await axios.post(
        '/api/media-orders/import',
        body,
    );
    
    return data;
};

const getIngestStatusList = async () => {
    const {data} = await axios('/api/ingest-sessions/statuses');
    
    return data;
};

const getIngestSession = async (id: any) => {
    return await axios(`/api/ingest-sessions/${id}`);
};

const getContentItem = async (id: any) => {
    return await axios(`/api/content-items/${id}/full`);
};

const updateContentItem = async (id: any, body: any) => {
    return await axios.put(
        `/api/content-items/${id}/full`,
        body,
    );
};

const getContentItemsList = async (params: any) => {
    const query = formQuery('/api/content-items', params);
    const {data} = await axios(query);
    
    return data;
};

const getIngestConfigs = async (params: any) => {
    const query = formQuery('/api/ingest-configs', params);
    const {data} = await axios(query);
    
    return data;
};

const getIngestList = async (params: any) => {
    const query = formQuery('/api/ingest-sessions', params);
    const {data} = await axios(query);
    
    return data;
};

const getIngestReport = async (id: any) => {
    const {data} = await axios(`/api/content-items/${id}/validation-reports/latest`);
    
    return data;
};

const getMediaOrderItems = async (id: any, params: any) => {
    const query = formQuery(`/api/media-orders/${id}/media-order-items`, params);
    const {data} = await axios(query);
    
    return data;
};

const getMediaOrders = async (params: any) => {
    const query = formQuery('/api/media-orders', params);
    const {data} = await axios(query);
    
    return data;
};

const getMrssDefaults = once(async () => {
    const {data} = await axios('/api/ingest-configs/mrss-defaults');
    return data;
});

export {
    restoreMediaOrder,
    deleteMediaOrder,
    getIngestSession,
    getContentPartnersList,
    getContentTypesList,
    getContentItem,
    updateContentItem,
    getContentItemsList,
    getIngestConfigs,
    getIngestList,
    getIngestStatusList,
    getIngestReport,
    getMediaOrderItems,
    getMediaOrders,
    getSearchedContentItems,
    getImportMediaOrder,
    createNewIngestItem,
    editIngestConfigItem,
    getIngestConfigItemForEditing,
    getQcJobsStatuses,
    getQcReportsStatuses,
    getMrssDefaults,
    getQcToolsMetadata,
};
